module.exports = __webpack_public_path__ + "static/media/downtown-campus.81b497c0.jp2";